import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import classNames from 'classnames';

import Table, { Column, Row } from '../../helpers/Table';

import style from './style.module.css';

/**
 * Stateless component for source companies used for merge.
 *
 * @param {object} props Props.
 * @param {List} props.companies Companies list.
 */
const CompanySourcesComponent = ({ companies }) => {
  /** Table rows. */
  const rows = companies.map(company => <Row key={company.get('id')} data={company} />);

  /** Companies cell value wrapper. */
  const handleWrapper = () => (fieldValue, data) => (
    <Link target="_blank" to={`/company/${data.get('id')}`}>
      {data.get('legalName')}
    </Link>
  );

  return (
    <div className={classNames(style.host, 'highlight no-padding wrap-border-full mb0')}>
      <Table bodyClassName={style.body} className={classNames(style.table, 'table-striped table-hover')}>
        <Column field="id" title="Source Companies Used To Merge" valueWrapper={handleWrapper()} />
        {rows}
      </Table>
    </div>
  );
};

CompanySourcesComponent.propTypes = {
  companies: PropTypes.instanceOf(List).isRequired,
};

export const CompanySources = memo(CompanySourcesComponent);
